export enum Int1AdminPermissions {
  DiscussionRound = 'discussion-round',
  Int1Phases = 'int1-phases',
}
